/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IExampleParent } from '../../../core/models/common/IExampleParent';
import { OasResponse } from '../../models/OasResponse';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends OasResponse
 * @author eric.wittmann@gmail.com
 */
export class Oas20Response extends OasResponse implements IExampleParent {
    public headers : Oas20Headers;

    public schema : Oas20Schema;

    public examples : Oas20Example;

    public constructor(name : string) {
        super(name);
        if(this.headers===undefined) this.headers = null;
        if(this.schema===undefined) this.schema = null;
        if(this.examples===undefined) this.examples = null;
    }

    /**
     * Creates an OAS 2.0 schema object.
     * @return {Oas20Schema}
     */
    public createSchema() : Oas20Schema {
        let rval : Oas20Schema = new Oas20Schema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Creates an OAS 2.0 headers object.
     * @return {Oas20Headers}
     */
    public createHeaders() : Oas20Headers {
        let rval : Oas20Headers = new Oas20Headers();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Creates an OAS 2.0 schema object.
     * @return {Oas20Example}
     */
    public createExample() : Oas20Example {
        let rval : Oas20Example = new Oas20Example();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }
}
Oas20Response["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Response";
Oas20Response["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IExampleParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];





import { Oas20Example } from './Oas20Example';


import { Oas20Schema } from './Oas20Schema';


import { Oas20Headers } from './Oas20Headers';

